<script>
  import { createScheduler } from 'scheduling-sdk'
  import { format, isPast, isAfter, roundToNearestMinutes } from 'date-fns'
  import { onMount, onDestroy } from 'svelte'
  
  let { vet, events = [], duration = 10, date, period = "day", gridCols = 4, fill = false, onSelect } = $props()

  let baseStartTime = $derived(period === "pm" ? new Date(`${date}T13:00:00`) : new Date(`${date}T08:00:00`))
  // let startTime = $derived(isPast(baseStartTime) ? roundToNearestMinutes(new Date(), { nearestTo: 15, roundingMethod: "ceil" }) : baseStartTime)
  let startTime = baseStartTime
  let endTime = $derived(period === "am" ? new Date(`${date}T13:00:00`) : new Date(`${date}T18:00:00`))

  // let slots = $state([])

  let lunchEvent = { start: new Date(`${date}T13:00:00`), end: new Date(`${date}T14:00:00`) }

  let allEvents = $derived([...events, lunchEvent])

  let gridClass = $derived(`grid grid-cols-${gridCols} gap-2 ${fill ? "flex-1 min-h-0" : "h-[30rem]"} overflow-y-auto content-start`)
  let slotClass = $derived(`bg-${vet.color}/80 p-2 rounded-md text-white text-xs text-center whitespace-nowrap`)

  
  let schedulerOptions = $derived({
    slotDuration: duration,
    padding: 0,
    slotSplit: 10,
    offset: 0
  })

  let scheduler = $derived.by(() => {
    if (isAfter(startTime, endTime)) return null
    return createScheduler(allEvents)
  })

  let slots = $derived.by(() => {
    if (!isAfter(endTime, startTime)) return []
    return scheduler?.findAvailableSlots(startTime, endTime, schedulerOptions) || []
  })

</script>

<div class="p-4 border border-gray-200 rounded-md w-full" class:flex={fill} class:flex-col={fill} class:h-full={fill}>

  <h4 class="text-sm font-semibold text-gray-500 text-center mb-4">{vet.name}</h4>

  {#if slots.length > 0}

    <div class={gridClass}>
    
      {#each slots as slot (slot.start)}
        <button class={slotClass} type="button" onclick={() => onSelect?.({ slot, vet })}>
          {format(slot.start, 'HH:mm')} - {format(slot.end, 'HH:mm')}
        </button>
      {/each}

    </div>

  {:else}
    <p class="text-xs text-gray-500 text-center">Aucun créneau disponible</p>
  {/if}
  
</div>